import types from './types';

/**
 * Set name of the new menu
 * @param {String} name
 */
const setMenuName = name => ({
  type: types.SET_NEW_MENU_NAME,
  name
});

/**
 * Set the dates of the new menu
 * @param {Moment[]} dates - array of moment objects
 */
const setMenuDates = dates => ({
  type: types.SET_NEW_MENU_DATES,
  dates
});

/**
 * Set who (rooms, centers, tagged groups) the new menu will be applied to
 * @param {Object[]} entities
 */
const setMenuEntities = entities => ({
  type: types.SET_NEW_MENU_ENTITIES,
  entities
});

/**
 * Set the new meals of a menu
 * @param {Object[Array]} meals
 */
const setMenuMeals = meals => ({
  type: types.SET_NEW_MENU_MEALS,
  meals
});

/**
 * Send request to create a new menu
 */
const createNewMenuRequest = () => ({
  type: types.CREATE_NEW_MENU_REQUEST
});

/**
 * Successful new menu creation
 */
const createNewMenuSuccess = () => ({
  type: types.CREATE_NEW_MENU_SUCCESS
});

/**
 * Unsuccessful new menu creation
 */
const createNewMenuFailure = error => ({
  type: types.CREATE_NEW_MENU_FAILURE,
  error
});

export default {
  setMenuName,
  setMenuDates,
  setMenuEntities,
  setMenuMeals,
  createNewMenuRequest,
  createNewMenuSuccess,
  createNewMenuFailure
};
